export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_LIST_MATERIALS(state, payload) {
    const materials = (payload.documents || []).map((item) => ({
      idMaterial: item.id,
      categoryMaterial: {
        ...((item.categorias !== undefined && item.categorias[0].opcionId !== undefined)
        && { opcionId: item.categorias[0].opcionId }),
        ...((item.categorias !== undefined && item.categorias[0].opcionId !== undefined)
        && { descripcion: item.categorias[0].descripcion })
      },
      brandMaterial: {
        ...((item.marca !== undefined && item.marca.opcionId !== undefined)
        && { opcionId: item.marca.opcionId }),
        ...((item.marca !== undefined && item.marca.opcionId !== undefined)
        && { descripcion: item.marca.descripcion })
      },
      nameMaterial: item.nombre,
      priceMaterial: item.precio,
      skuMaterial: item.SKU,
      imageMaterial: '',
      currencyMaterial: item.moneda,
      stateMaterial: item.estado !== undefined ? item.estado : 'inactive',
      actions: '',
      ...(item.servicios
        && { materialServices: item.servicios }),
    }));
    state.listMaterials = materials;
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_MATERIAL_REQUEST_DETAIL(state, payload) {
    state.materialRequestsDetail = payload;
  },
  SET_LIST_CATALOGS(state, payload) {
    state.listCatalogs = [];
    const catalogs = payload.map((item) => ({
      catalogId: item.id,
      ...(item.descripcion !== undefined
        && { catalogName: item.descripcion }),

      ...(item.categorias.length !== undefined
        && { catalogCategorys: item.categorias }),

      ...(item.materiales.length !== undefined
        && { catalogMaterials: item.materiales }),

      catalogState: item.estado !== undefined ? item.estado : 'inactive',
    }));
    state.listCatalogs = catalogs;
  },
  SET_LIST_CATEGORYS(state, payload) {
    const category = payload.map((item) => ({
      categoryName: item.descripcion,
      categoryId: item.opcionId
    }));
    state.listCategorys = category;
  },
  SET_LIST_BRANDS(state, payload) {
    const brand = payload.map((item) => ({
      brandName: item.descripcion,
      brandId: item.opcionId
    }));
    state.listBrands = brand;
  },
  SET_OPTION_USERS(state, payload) {
    state.optionUsers = payload;
  },
  REMOVE_OPTION_USERS(state, payload) {
    state.optionUsers = state.optionUsers
      .filter((userFilter) => userFilter.id !== payload.id);
  },
  ADD_OPTION_USER(state, payload) {
    state.optionUsers = [
      ...state.optionUsers,
      payload
    ];
  },
  SET_ENTITIES(state, payload) {
    state.entities = payload;
  },
  SET_LIST_MATERIALS_REQUESTS(state, payload) {
    state.listMaterialsRequests = [];
    const request = payload.documentos.map((item) => ({
      ...item,
      numero: item.numero.padStart(7, '0')
    }));
    state.listMaterialsRequests = request;
    state.pagination = {
      items: Number.parseInt(payload.totalElementos, 10),
      pages: Number.parseInt(payload.totalPaginas, 10)
    };
  },
  SET_SERVICES(state, payload) {
    state.services = payload;
  },
};
